import { useState, useEffect } from 'preact/hooks';
import { api } from '../api/client';
import { Button, ListSkeleton, SkeletonBar } from '../components/ui';
import { T } from '../styles/tokens';

const STATUS_LABELS: Record<string, { label: string; color: string }> = {
  open: { label: 'Aberto', color: T.warning },
  in_progress: { label: 'Em andamento', color: T.primary },
  resolved: { label: 'Resolvido', color: T.success },
  closed: { label: 'Fechado', color: T.textMuted },
};

const SEVERITY_COLORS: Record<string, string> = {
  low: T.textMuted, medium: T.warning, high: T.warning, critical: T.danger,
};

export function AdminBugReportsPage(_props: { path?: string }) {
  const [reports, setReports] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');

  const fetchReports = () => {
    setLoading(true);
    const url = filter ? `/admin/bug-reports?status=${filter}` : '/admin/bug-reports';
    api.get<any>(url).then(r => setReports(r?.reports || [])).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(() => { fetchReports(); }, [filter]);

  const updateStatus = async (id: string, status: string) => {
    await api.patch(`/admin/bug-reports/${id}`, { status });
    fetchReports();
  };

  return (
    <div style={{ padding: '40px 24px', maxWidth: 1100, margin: '0 auto' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: T.text, margin: '0 0 8px' }}>Bug Reports</h1>
      <p style={{ fontSize: 14, color: T.textMuted, margin: '0 0 24px' }}>Relatorios de bugs enviados pelos usuarios</p>

      {/* Filter */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        {['', 'open', 'in_progress', 'resolved', 'closed'].map(s => (
          <Button key={s} variant={filter === s ? 'primary' : 'ghost'} size="sm" onClick={() => setFilter(s)}>
            {s === '' ? 'Todos' : STATUS_LABELS[s]?.label || s}
          </Button>
        ))}
      </div>

      {loading ? (
        <div style={{ padding: 40 }}>
          <ListSkeleton rows={4} />
        </div>
      ) : reports.length === 0 ? (
        <div style={{ color: T.textMuted, padding: 40, textAlign: 'center' }}>Nenhum bug report encontrado</div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                {['Titulo', 'Severidade', 'Status', 'Usuario', 'Data', 'Acoes'].map(h => (
                  <th key={h} style={{ textAlign: 'left', padding: '10px 12px', color: T.textMuted, borderBottom: `1px solid ${T.whiteAlpha8}`, fontWeight: 600 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {reports.map((r: any) => {
                const st = STATUS_LABELS[r.status] || { label: r.status, color: T.textMuted };
                return (
                  <tr key={r.id} style={{ borderBottom: '1px solid #2F2F2F' }}>
                    <td style={{ padding: '10px 12px', color: T.text, maxWidth: 300 }}>
                      <div style={{ fontWeight: 600, marginBottom: 2 }}>{r.title}</div>
                      <div style={{ fontSize: 12, color: T.textMuted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 280 }}>{r.description}</div>
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, color: SEVERITY_COLORS[r.severity] || T.textMuted, background: `${SEVERITY_COLORS[r.severity] || T.textMuted}15` }}>
                        {r.severity}
                      </span>
                    </td>
                    <td style={{ padding: '10px 12px' }}>
                      <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, color: st.color, background: `${st.color}15` }}>{st.label}</span>
                    </td>
                    <td style={{ padding: '10px 12px', color: T.textSecondary, fontSize: 12 }}>{r.user_email || r.user_id?.slice(0, 8)}</td>
                    <td style={{ padding: '10px 12px', color: T.textMuted, fontSize: 12, whiteSpace: 'nowrap' }}>{new Date(r.created_at).toLocaleString('pt-BR')}</td>
                    <td style={{ padding: '10px 12px' }}>
                      <select
                        value={r.status}
                        onChange={(e: any) => updateStatus(r.id, e.target.value)}
                        style={{ padding: '4px 8px', borderRadius: 4, border: `1px solid ${T.whiteAlpha8}`, background: T.bg, color: T.textSecondary, fontSize: 12, cursor: 'pointer' }}
                      >
                        <option value="open">Aberto</option>
                        <option value="in_progress">Em andamento</option>
                        <option value="resolved">Resolvido</option>
                        <option value="closed">Fechado</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
